import React from 'react';
import { Pagination } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

import './style.scss';

const Pager = (props) => {
  const { t } = useTranslation();
  const {
    totalPages,
    currentPage,
    setCurrentPage,
    // Temporarily added to fix the issue with the pagination needed an offset.
    // https://uncinc.monday.com/boards/1506051082/pulses/8986081856
    correctSetter = true,
  } = props;

  const _setCurrentPage = (index) => {
    setCurrentPage(correctSetter ? (index - 1) : index);
  };

  return (
    <Pagination
      {...props}
      currentPage={correctSetter ? (currentPage + 1) : currentPage}
      setCurrentPage={_setCurrentPage}
      pageRangeDisplayed={totalPages > 6 ? 2 : 5}
      marginPagesDisplayed={totalPages > 6 ? 1 : 0}
      previousLabel={<a className="Pagination__previous"><i className="icon icon-before icon-arrow-right icon-variant-2" /><span>{t('general.prev')}</span></a>}
      nextLabel={<a className="Pagination__next"><span>{t('general.next')}</span><i className="icon icon-after icon-arrow-right icon-variant-2" /></a>}
      key={`pagination-${totalPages}-${currentPage}`}
    />
  );
};

export default Pager;
